import gql from 'graphql-tag';

export const CreatePageByBlueprintMutation =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation CreatePageByBlueprintMutation(
			$spaceKey: String!
			$blueprint: String!
			$parentPageId: String
			$title: String
			$subType: String
			$attemptSpaUrlResponse: Boolean
		) @experimental {
			experimentalPublishPageByBlueprint(
				spaceKey: $spaceKey
				contentId: $parentPageId
				blueprint: $blueprint
				title: $title
				subType: $subType
				attemptSpaUrlResponse: $attemptSpaUrlResponse
			) {
				links {
					draftUrl
				}
			}
		}
	`;
